import { render, staticRenderFns } from "./ContestAdwardListComponent.vue?vue&type=template&id=5072e2ab"
import script from "./ContestAdwardListComponent.vue?vue&type=script&lang=js"
export * from "./ContestAdwardListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports